export const breadcrumbList = [
  {
    name: '商品管理',
    path: ''
  },
  {
    name: '卡项列表',
    path: ''
  }
]
